import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { ContextService } from '../services/context.service';
import { MembershipService } from '../services/membership.service';
import { UserService } from '../services/user.service';
import { waitForAuthUser } from '../utils/wait-for-auth';

export const authGuard: CanActivateFn = async (): Promise<boolean> => {
  const auth = inject(Auth);
  const router = inject(Router);
  const contextService = inject(ContextService);
  const membershipService = inject(MembershipService);
  const userService = inject(UserService);

  try {
    const user = await waitForAuthUser(auth);

    if (!user) {
      router.navigate(['/auth/login'], { replaceUrl: true });
      return false;
    }

    if (!contextService.isSessionReady()) {
      await Promise.all([
        userService.getUser(),
        membershipService
          .getUserMemberships()
          .then(() => contextService.loadUserContexts()),
      ]);
      contextService.markSessionReady();
    }

    return true;
  } catch (error) {
    console.error('Auth guard error:', error);
    router.navigate(['/auth/login'], { replaceUrl: true });
    return false;
  }
};
